// import * as types from './type.js'
import utils from "@/utils/index";
export default {
  UPDATE_USERINFO(
    state,
    { wstoken, firstname, lastname, username, userid, userpictureurl }
  ) {
    state.userinfo.wstoken = wstoken || state.userinfo.wstoken;
    state.userinfo.firstname = firstname || state.userinfo.firstname;
    state.userinfo.lastname = lastname || state.userinfo.lastname;
    state.userinfo.username = username || state.userinfo.username;
    state.userinfo.userid = userid || state.userinfo.userid;
    state.userinfo.dateTime =
      utils.formatTime(new Date(), "-", false) || state.userinfo.dateTime;
    state.userinfo.userpictureurl =
      userpictureurl || state.userinfo.userpictureurl;
  }
};
